import { createApp } from "vue"
import App from "./App.vue"
import "no-darkreader"

const app = createApp(App)

import i18n from "./i18n"
app.use(i18n)

import naive from "naive-ui"
app.use(naive)

import router from "@/script/router"
app.use(router)

import storage from "@/script/storage"
app.use(storage)

import { initMaps } from "@/script/data"
import { extractBuildNumber } from "@/script/helper"
initMaps()

// store build timestamp and remove it from dom
storage.state.session.buildNumber = extractBuildNumber(document.documentElement)

app.mount("#app")
